(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomMaterialTypeAttributeDetailController', CustomMaterialTypeAttributeDetailController);

    CustomMaterialTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomMaterialTypeAttribute'];

    function CustomMaterialTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomMaterialTypeAttribute) {
        var vm = this;

        vm.customMaterialTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customMaterialTypeAttributeUpdate', function(event, result) {
            vm.customMaterialTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
